<template>
  <div class="intro">
    <div v-if="showIntro">
    <h1 class="intro__h1 h1">badenova Wertekompass</h1>
    <p class="intro__h2 h2">Uns interessiert Ihre Persönlichkeit!</p>
    <img class="intro__img" :src='this.$root.$data.imagePrefix +"intro.gif"'>
    <div class="intro__text">
      <p>Wir bei badenova sind der festen Überzeugung, dass jeder von uns am besten sein kann, wenn er einfach nur er selbst sein darf.</p>
      <p class="intro__p">Tag für Tag bringen unsere 1.550 Mitarbeitenden ihre einzigartigen Ideen, ihre Kompetenz und ihre Talente ein und machen unsere Unternehmensgruppe und Unternehmenskultur dadurch einzigartig. Unsere gemeinsamen Werte motivieren uns und sind immer wieder Ansporn zugleich.</p>
      <p class="intro__p">Ein kurzer Selbstcheck gibt Ihnen die Möglichkeit herauszufinden, ob Sie zu uns und wir zu Ihnen passen. Antworten Sie spontan auf die folgenden Fragen. Am Ende wissen Sie, ob Ihnen unsere gelebten Werte zusagen.</p>
    </div>
     <button class="intro__button button button--orange button--fixed" @click="startQuestions">Weiter</button>
     </div>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  data: function() {
    return {
      showIntro: true
    }
  },
  props: {
    headline: String,
    text: String
  },
  methods: {
    goToTop: function() {
      window.scrollTo(document.querySelector('#corporate-values').offsetTop, 0);
    },
    trackStartApplication: function() {
      if(window.dataLayer !== undefined) {
        window.dataLayer.push({
          'event':'event',
          'eventCategory': 'Corporate Values Application',
          'eventAction': 'Application started',
          'eventLabel': 'yes'
        });
      }
    },
    startQuestions: function() {
      this.trackStartApplication();
      this.$emit('changeViewTo', 'questions');
    }
  }
}
</script>
<style scoped lang="scss">
@keyframes fadein {
    0% { opacity:0;  max-height:0px; }
    66% { opacity:0; max-height:0px;}
    100% { opacity:1;  max-height:500px; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    0% { opacity:0;  max-height:0px; }
    66% { opacity:0; max-height:0px;}
    100% { opacity:1;  max-height:500px;}
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    0% { opacity:0;  max-height:0px; }
    66% { opacity:0; max-height:0px;}
    100% { opacity:1;  max-height:500px;}
}

/* Internet Explorer */
@-ms-keyframes fadein {
   0% { opacity:0; }
    66% { opacity:0; }
    100% { opacity:1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    0% { opacity:0; }
    66% { opacity:0; }
    100% { opacity:1; }
}

@keyframes opacity {
    0% { opacity:0; }
    100% { opacity:1; }
}

/* Firefox < 16 */
@-moz-keyframes opacity {
    0% { opacity:0; }
    100% { opacity:1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes opacity {
    0% { opacity:0; }
    100% { opacity:1; }
}

/* Internet Explorer */
@-ms-keyframes opacity {
   0% { opacity:0; }
    100% { opacity:1; }
}

/* Opera < 12.1 */
@-o-keyframes opacity {
    0% { opacity:0; }
    100% { opacity:1; }
}

@keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(3780deg); }
}
/* Firefox < 16 */
@-moz-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes spin {
  10% { -webkit-transform: rotate(360deg); }
  90% { -webkit-transform: rotate(20880deg); }
  100% { -webkit-transform: rotate(21600deg); }
}

/* Internet Explorer */
@-ms-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

/* Opera < 12.1 */
@-o-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

.intro {
  @media (min-width: 768px) {
    position: relative;
  }
  &__text {
    opacity: 0;
    padding: 0 25px;
    background: linear-gradient(
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.8) 30%,
        rgba(255, 255, 255, 1) 100%);
    animation: 3s ease 0s normal forwards 1 opacity;

    @media (min-width: 768px) {
        padding: 0;
        margin: 0 auto;
        width: 600px;
    }
  }

  &__p {
    margin-top: 15px;
  }

  &__img {
    width: 100%;
    height: auto;

    @media (min-width: 768px) {
      width: 500px;
    }
  }

  &__h1 {
    text-align: center;
    opacity: 0;
    animation: 5s ease 0s normal forwards 1 opacity;

    @media (min-width: 768px) {
      font-size: 42px;
    }
  }
  &__h2 {
    margin-top: 20px;
    opacity: 0;
    animation: 7s ease 0s normal forwards 1 opacity;
  }
}
.introCompass {
  position: relative;
  width: 300px;
  height: 300px;
  margin: 0 auto;

  @media(min-width: 768px) {
    width: 600px;
    height: 600px;
  }
  &__text {
    width: 300px;
    margin: 0px auto 25px;
    text-align: center;

    @media(min-width: 768px) {
      width: 600px;
    }
  }

  &__background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__needle {
    position: absolute;
    top: 0;
    left: 0;
    width: 300px;
    height: 300px;
    animation: 5s ease 0s normal forwards 1 spin;

    @media (min-width: 768px) {
    width: 600px;
    height: 600px;;
  }
  }
}
</style>
